import React from 'react';
import Dashboard from './Dashboard';

const AnalystPage = props => (<Dashboard withoutJurisdiction="40" {...props} />);

export default AnalystPage;



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/Analyst.js